<template>
  <div>
    <div class="ts-space-y-4">
      <div class="row">
        <div class="col-md-7">
          <form class="form-horizontal ts-space-y-3">
            <div class="row">
              <label class="col-md-3 col-form-label ts-text-xs required ts-font-light">{{ $t('promotion.eventName')
              }}</label>
              <div class="col-md-8">
                <input v-model="model.promotion_name" type="text" class="form-control" />
                <div class="validate ts-text-xs" v-if="errors.has('promotion_name')">{{ errors.first('promotion_name')
                }}</div>
              </div>
            </div>
            <div class="row">
              <label class="col-md-3 col-form-label ts-text-xs required ts-font-light">{{ $t('promotion.startDate')
              }}</label>
              <div class="col-md-8">
                <a-date-picker v-model="model.promo_start_date" class="ts-w-full" format="DD-MM-YYYY"
                  valueFormat="DD-MM-YYYY"></a-date-picker>
                <div class="validate ts-text-xs" v-if="errors.has('promo_start_date')">{{
                  errors.first('promo_start_date') }}</div>
              </div>
            </div>
            <div class="row">
              <label class="col-md-3 col-form-label ts-text-xs"></label>
              <div class="col-md-8">
                <ts-checkbox v-model="model.is_no_end_date" class="ts-font-light"
                  @change="() => model.promo_end_date = null">{{ $t('promotion.tillFurtherNotice') }}</ts-checkbox>
              </div>
            </div>
            <div class="row">
              <label class="col-md-3 col-form-label ts-text-xs ts-font-light"
                :class="!model.is_no_end_date ? 'required' : null">{{ $t('promotion.endDate') }}</label>
              <div class="col-md-8">
                <a-date-picker v-model="model.promo_end_date" :disabled="model.is_no_end_date" class="ts-w-full"
                  format="DD-MM-YYYY" valueFormat="DD-MM-YYYY"></a-date-picker>
                <div class="validate ts-text-xs" v-if="errors.has('promo_end_date')">{{ errors.first('promo_end_date')
                }}</div>
              </div>
            </div>
          </form>
        </div>
        <div class="col-md-3">
          <div class="ts-w-full ts-h-full ts-border ts-border-gray-300 ts-rounded-md ts-p-3">
            <BranchList v-model="model" />
            <div class="validate ts-text-xs" v-if="errors.has('branch_id_list')">{{ errors.first('branch_id_list') }}
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="ts-w-full ts-h-full ts-border ts-border-gray-300 ts-rounded-md ts-p-3">
            <Modules v-model="model" />
            <div class="validate ts-text-xs" v-if="errors.has('branch_id_list')">{{ errors.first('branch_id_list') }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <ScheduleDay v-model="model" :validate="errors" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <BuyItemFreeItem v-model="model" :validate="errors" />
          <div class="validate ts-text-xs" v-if="errors.has('condition')">
            {{ errors.first('condition') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 ts-flex ts-items-center ts-space-x-3 ts-justify-end">
          <ts-button @click.prevent="$router.push({ name: 'promotion' })">{{ $t('cancel') }}</ts-button>
          <ts-button color="primary" outline :waiting="waiting_new" @click.prevent="onSaveAddNew">{{ $t('save_add_new')
          }}</ts-button>
          <ts-button :waiting="waiting" @click.prevent="onSave" color="primary">{{ $t('save') }}</ts-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import BranchList from './branch-list'
import Modules from './modules'
import BuyItemFreeItem from './buy-item-free-item-condition'
import ScheduleDay from './schedule_day'

export default {
  name: 'buyItemFreeItem',
  components: {
    BranchList,
    Modules,
    BuyItemFreeItem,
    ScheduleDay
  },
  data() {
    return {
      loading: false,
      waiting: false,
      waiting_new: false,
      errors: new Errors(),
      model: {
        promotion_name: '',
        promo_type_id: 4,
        is_no_end_date: false,
        promo_start_date: '',
        promo_end_date: '',
        branch_id_list: [],
        modules: [],
        condition: [],
        promo_schedule_list: []
      }
    }
  },
  created() {
    this.createDay()
  },
  methods: {
    ...mapActions('promotion/buyItemFreeItem', ['store']),
    onSave() {
      this.waiting = true
      this.errors = new Errors()
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'promotion' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onSaveAddNew() {
      this.waiting_new = true
      this.errors = new Errors()
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    createDay() {
      this.model.promo_schedule_list = []
      for (var i = 1; i <= 7; i++) {
        this.model.promo_schedule_list.push({
          day_id: null,
          time_from: null,
          time_to: null
        })
      }
    },
    clearInput() {
      this.model.promotion_name = ''
      this.model.prom_type_id = 4
      this.model.is_no_end_date = false
      this.model.promo_start_date = ''
      this.model.promo_end_date = ''
      this.model.branch_id_list = []
      this.model.condition = []
      this.model.promo_schedule_list.forEach(element => {
        element.day_id = null
        element.time_from = null
        element.time_to = null
      });
    }
  }
}
</script>